const accountApiEndpoints = {
    lastAction: '/uac/user/lastactions',
    confirmAccount: '/lg/user/confirmaccount',
    userfavcoins: '/lg/user/userfavcoins',
    userdeletefavcoins: '/lg/user/deluserfavcoins',
};

export default accountApiEndpoints;
